import { once } from '@ember/runloop';

import type { APIData } from 'webapp-types';

import CustomQuerySetupWizardCommonStepMetricDefinitionComponent from 'webapp/components/custom-query/setup/wizard/common/step-metric-definition';
import type { Args } from 'webapp/components/custom-query/setup/wizard/sheet/step-common';

import CustomMetricSetupFormItemField from 'webapp/models-custom/custom-metric-setup-form/item/field';

export default class CustomQuerySetupWizardSheetStepMetricDefinitionComponent extends CustomQuerySetupWizardCommonStepMetricDefinitionComponent<Args> {
	get metricDefinitionField(): CustomMetricSetupFormItemField {
		return this.args.form.items.find((item) => {
			return item instanceof CustomMetricSetupFormItemField && item.isMetricDefinition;
		}) as CustomMetricSetupFormItemField;
	}

	getInitialQueryName(): string {
		return this.args.form.getMetricNameForSelectedFields();
	}

	// ---- start stuff for QueryBuilderFormMetricDefinitionBaseComponent ---

	get model(): APIData.CustomQuery.MetricDefinitionValue {
		return this.metricDefinitionField.value as APIData.CustomQuery.MetricDefinitionValue;
	}

	save(data: APIData.CustomQuery.MetricDefinitionValue): void {
		const field = this.metricDefinitionField;
		field.value = data;
		field.updateValueFormatted();
		once(this, this.queryPreview);
	}

	// ---- end stuff for QueryBuilderFormMetricDefinitionBaseComponent ----
}
